import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { GetCaseEventsRq, LoanCaseEventDTO } from "@smartx/mikro-vt-client-api"
import { caseEventsApi } from "../../api/apiClient"
import { RequestHeader } from "../../utils/utils"
import type { RootState } from "../store"

interface CaseEventsState {
  list: Array<LoanCaseEventDTO>
  isLoading: boolean
  error: boolean
}

const initialState: CaseEventsState = {
  list: undefined,
  isLoading: false,
  error: false,
}

const rq: GetCaseEventsRq = { header: new RequestHeader() }

export const getCaseEvents = createAsyncThunk(
  "caseEvents/getCaseEvents",
  async () => {
    const response = await caseEventsApi.getCaseEvents(rq)
    return response?.data
  },
)

export const caseEventsSlice = createSlice({
  name: "caseEvents",
  initialState,
  reducers: {
    setCaseEvents: (state, action: PayloadAction<LoanCaseEventDTO[]>) => {
      state.list = action.payload
    },
    clearCaseEvents: (state) => {
      state.list = undefined
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCaseEvents.pending, (state) => {
        state.isLoading = true
        state.error = false
      })
      .addCase(getCaseEvents.fulfilled, (state, action) => {
        state.list = action.payload.loanCaseEvents
        state.isLoading = false
        state.error = false
      })
      .addCase(getCaseEvents.rejected, (state) => {
        state.list = undefined
        state.isLoading = false
        state.error = true
      })
  },
})

export const { setCaseEvents, clearCaseEvents } = caseEventsSlice.actions

export const selectCaseEvents = (state: RootState) => state.caseEvents.list

export default caseEventsSlice.reducer
